export const CHECKOUT_URL = 'https://golf-coach-pro.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offer'

export const PRODUCT_NAME = 'GOLF COACH PRO™'

export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/8BDG3EEX1At255ZFgbp1vv/ChatGPT-Image-18-ago-2026_-08_58_31-p.m..webp'

export const PRODUCT_ALT =
  'GOLF COACH PRO™ — complete 6-in-1 ready-to-use golf coaching system box set'

export const PRICE_FULL = '$97'

export const PRICE_TODAY = '$27'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'
